import { render, staticRenderFns } from "./DeliveryLogsShopClick.vue?vue&type=template&id=635c5902"
import script from "./DeliveryLogsShopClick.vue?vue&type=script&lang=js"
export * from "./DeliveryLogsShopClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports